import { render, staticRenderFns } from "./StepPage.vue?vue&type=template&id=245097f1&scoped=true&"
import script from "./StepPage.vue?vue&type=script&lang=js&"
export * from "./StepPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245097f1",
  null
  
)

export default component.exports